import React, { useState } from "react";
import { Button, Message, TextArea } from "../../../BP2Components";

import "../../StripeWidget/StripeWidget.less";
import IntlMessages from "../../../../util/IntlMessages";
import { useDispatch } from "react-redux";
import { setWidgetInSheetParams } from "../../../../appRedux/actions/Boards";
import { useIntl } from "react-intl";

type StripeWidgetSettingsInterface = { value: any; data: any };

const StripeWidgetSettings: React.FC<StripeWidgetSettingsInterface> = ({ value, data }) => {
   const [settings, setSettings] = useState({
      ...value
   });

   const dispatch = useDispatch();

   const intl = useIntl();

   const handleTextAreaChange = (e) => {
      const newValue = e.target.value;
      setSettings((prevSettings) => ({
         ...prevSettings,
         base64HtmlPl: newValue
      }));
   };

   const handleSave = () => {
      Message.success(intl.formatMessage({ id: "global.saved" }));
      dispatch(setWidgetInSheetParams(settings));
      setSettings(settings);
   };

   return (
      <>
         <div className="stripe-widget-settings">
            <div className="settings-section">
               <span className="label">base64HtmlPl: </span>
               <div className="value">
                  <TextArea
                     value={settings.base64HtmlPl || ""}
                     onChange={handleTextAreaChange}
                     placeholder="Wklej kod stripe..."
                  />
               </div>
            </div>
            <div className="save-button-container">
               <Button onClick={handleSave} key="btn" buttonType="primary" htmlType="submit">
                  <IntlMessages id="global.preview" />
               </Button>
            </div>
         </div>
      </>
   );
};

export default StripeWidgetSettings;
